import { useState } from 'react';
import { categories } from '@/mocks/comics';
import { useNavigate } from 'react-router-dom';

interface CategoryTabsProps {
  activeSlug: string;
  onCategoryChange?: (slug: string) => void;
}

export default function CategoryTabs({ activeSlug, onCategoryChange }: CategoryTabsProps) {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    if (onCategoryChange) {
      onCategoryChange(slug);
    } else {
      navigate(`/category/${slug}`);
    }
  };

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => {
        const isActive = activeSlug === cat.slug;
        return (
          <button
            key={cat.slug}
            onClick={() => handleClick(cat.slug)}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-background-50 shadow-sm'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${cat.icon} text-sm`}></i>
            </span>
            {cat.name}
          </button>
        );
      })}
    </div>
  );
}